// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "g#puzzleSVG {\n  fill: var(--moduleBoxColor);\n}\n.puzzle-bloc:hover .title {\n  background-color: var(--selectedColor);\n}\n.puzzle-bloc:hover .puzzle-part:after {\n  background-color: var(--modalColor) !important;\n}\n.puzzle-part:after {\n  transition: linear all 0.1s !important;\n}\n", ""]);
// Exports
module.exports = exports;
